import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { Link, useLocation } from "react-router-dom";
import { getFormatTime, getLocalizedDate } from "@/utils/common";
import PaymentMethods from "@/_MiniApps/RemainingPaymentComponent/components/PaymentMethods/PaymentMethods";
import { useState } from "react";
import { useLang } from "@/common/Contexts/LanguageContext";
import SharedRemDataComp from "./components/SharedRemDataComp";
import ArrowType2SVG from "../../SVGObjects/UiKit/ArrowType2SVG";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import useHelpers from "@hooks/useHelpers";
import WarrantyRemaining from "@/_MiniApps/RemainingPaymentComponent/components/WarrantyRemaining";
import { twMerge } from "tailwind-merge";
import { api__setWarrantyRemainingPayment } from "@/apis/checkout/remainingPayments";
var getRemainingAmount = function getRemainingAmount(order) {
  if (order !== null && order !== void 0 && order.remaining_price_payed) {
    return parseInt(order.remaining_price_payed.split(".")[0].replace(",", ""), 10);
  }
  if (order !== null && order !== void 0 && order.remaining_amount) {
    return parseInt(order.remaining_amount.split(".")[0].replace(",", ""), 10);
  }
  return 0;
};
var RemainingPaymentComponent = function RemainingPaymentComponent(_ref) {
  var _localOrder$warrantyV, _warrantyV2$items$map, _warrantyV2$items, _warrantyV2$selected, _warrantyV2$selected$, _resolvedWarrantyOpti, _warrantyV2$selected$2, _warrantyV2$selected2, _warrantyV2$selected3;
  var _ref$isCash = _ref.isCash,
    isCash = _ref$isCash === void 0 ? false : _ref$isCash,
    buttonLoading = _ref.buttonLoading,
    order = _ref.order,
    sadad = _ref.sadad,
    hasSadad = _ref.hasSadad,
    sadadError = _ref.sadadError,
    banks = _ref.banks,
    enableAllPayments = _ref.enableAllPayments,
    title = _ref.title,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "" : _ref$id,
    _ref$date = _ref.date,
    date = _ref$date === void 0 ? null : _ref$date,
    _ref$backFromTracking = _ref.backFromTracking,
    backFromTracking = _ref$backFromTracking === void 0 ? false : _ref$backFromTracking,
    _ref$stepStatus = _ref.stepStatus,
    stepStatus = _ref$stepStatus === void 0 ? "" : _ref$stepStatus,
    _ref$showBackLink = _ref.showBackLink,
    showBackLink = _ref$showBackLink === void 0 ? false : _ref$showBackLink,
    _ref$updateSadadError = _ref.updateSadadError,
    updateSadadError = _ref$updateSadadError === void 0 ? null : _ref$updateSadadError,
    _ref$isFinance = _ref.isFinance,
    isFinance = _ref$isFinance === void 0 ? false : _ref$isFinance,
    _ref$warrantyOptions = _ref.warrantyOptions,
    warrantyOptions = _ref$warrantyOptions === void 0 ? [] : _ref$warrantyOptions;
  var lang = useLang();
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    navigateTo = _useHelpers.navigateTo;
  var _useLocation = useLocation(),
    state = _useLocation.state;
  var _useState = useState(false),
    canSubmit = _useState[0],
    setCanSubmit = _useState[1];
  var _useState2 = useState(order),
    localOrder = _useState2[0],
    setLocalOrder = _useState2[1];
  var isPaid = getRemainingAmount(localOrder) <= 0 || stepStatus === "approved";
  var warrantyV2 = (_localOrder$warrantyV = localOrder === null || localOrder === void 0 ? void 0 : localOrder.warrantyV2) !== null && _localOrder$warrantyV !== void 0 ? _localOrder$warrantyV : null;
  var toWarrantyOption = function toWarrantyOption(item) {
    var _item$price, _item$badge;
    return {
      id: item.id,
      name: item.title,
      duration: "",
      mileage: item.subtitle,
      price: (item === null || item === void 0 ? void 0 : (_item$price = item.price) === null || _item$price === void 0 ? void 0 : _item$price.current) === 0 ? item.price.current || null : item.price.current_formatted || null,
      original_price: item.price.original_formatted,
      badge_label: (_item$badge = item.badge) === null || _item$badge === void 0 ? void 0 : _item$badge.text,
      years: item === null || item === void 0 ? void 0 : item.years
    };
  };
  var resolvedWarrantyOptions = (_warrantyV2$items$map = warrantyV2 === null || warrantyV2 === void 0 ? void 0 : (_warrantyV2$items = warrantyV2.items) === null || _warrantyV2$items === void 0 ? void 0 : _warrantyV2$items.map(toWarrantyOption)) !== null && _warrantyV2$items$map !== void 0 ? _warrantyV2$items$map : warrantyOptions;
  var initialWarranty = warrantyV2 !== null && warrantyV2 !== void 0 && warrantyV2.selected ? {
    id: warrantyV2.selected.id,
    name: warrantyV2.selected.title,
    duration: String(warrantyV2.selected.years),
    mileage: warrantyV2.selected.subtitle,
    price: ((_warrantyV2$selected = warrantyV2.selected) === null || _warrantyV2$selected === void 0 ? void 0 : (_warrantyV2$selected$ = _warrantyV2$selected.price) === null || _warrantyV2$selected$ === void 0 ? void 0 : _warrantyV2$selected$.current) === 0 ? warrantyV2.selected.price.current.toString() || null : warrantyV2.selected.price.current_formatted || null,
    original_price: warrantyV2.selected.price.original_formatted
  } : (_resolvedWarrantyOpti = resolvedWarrantyOptions[0]) !== null && _resolvedWarrantyOpti !== void 0 ? _resolvedWarrantyOpti : null;
  var isDefaultWarrantySelected = ((_warrantyV2$selected$2 = warrantyV2 === null || warrantyV2 === void 0 ? void 0 : (_warrantyV2$selected2 = warrantyV2.selected) === null || _warrantyV2$selected2 === void 0 ? void 0 : (_warrantyV2$selected3 = _warrantyV2$selected2.price) === null || _warrantyV2$selected3 === void 0 ? void 0 : _warrantyV2$selected3.current) !== null && _warrantyV2$selected$2 !== void 0 ? _warrantyV2$selected$2 : 0) === 0;
  var _useState3 = useState(initialWarranty),
    selectedWarranty = _useState3[0],
    setSelectedWarranty = _useState3[1];
  var _useState4 = useState(false),
    isWarrantyUpdating = _useState4[0],
    setIsWarrantyUpdating = _useState4[1];
  var handleWarrantySelect = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(option) {
      var _updatedOrder$warrant, _updatedOrder$warrant2;
      var updatedOrder;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setIsWarrantyUpdating(true);
            _context.n = 1;
            return api__setWarrantyRemainingPayment(localOrder === null || localOrder === void 0 ? void 0 : localOrder.order_uuid, option.id);
          case 1:
            updatedOrder = _context.v;
            setSelectedWarranty({
              id: updatedOrder.warrantyV2.selected.id,
              name: updatedOrder.warrantyV2.selected.title,
              duration: String(updatedOrder.warrantyV2.selected.years),
              mileage: updatedOrder.warrantyV2.selected.subtitle,
              price: ((_updatedOrder$warrant = updatedOrder.warrantyV2.selected) === null || _updatedOrder$warrant === void 0 ? void 0 : (_updatedOrder$warrant2 = _updatedOrder$warrant.price) === null || _updatedOrder$warrant2 === void 0 ? void 0 : _updatedOrder$warrant2.current) === 0 ? updatedOrder.warrantyV2.selected.price.current.toString() || null : updatedOrder.warrantyV2.selected.price.current_formatted || null,
              original_price: updatedOrder.warrantyV2.selected.price.original_formatted
            });
            setIsWarrantyUpdating(false);
            if (!updatedOrder) {
              _context.n = 2;
              break;
            }
            setLocalOrder(updatedOrder);
            return _context.a(2, true);
          case 2:
            return _context.a(2, false);
        }
      }, _callee);
    }));
    return function handleWarrantySelect(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var isBackVisible = !canSubmit && (backFromTracking || (state === null || state === void 0 ? void 0 : state.backFromSteps));
  var localizedDate = date ? getLocalizedDate(new Date(date), lang, true) : {
    day: "",
    date: ""
  };
  var localizedTime = date ? getFormatTime(new Date(date), lang) : {
    time: "",
    format: ""
  };
  var sharedDataProps = {
    order: localOrder,
    hideData: true,
    isCash: isCash,
    isFinance: isFinance
  };
  var paymentMethodsProps = {
    buttonLoading: buttonLoading,
    order: localOrder,
    sadad: sadad,
    hasSadad: hasSadad,
    sadadError: sadadError,
    banks: banks,
    enableAllPayments: enableAllPayments,
    className: "",
    canSubmit: canSubmit,
    setCanSubmit: setCanSubmit,
    updateSadadError: updateSadadError,
    isFinance: isFinance
  };
  var renderHeader = function renderHeader() {
    var _warrantyV2$items2, _localOrder$payment_t, _warrantyV2$items3;
    if (isPaid) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col items-center justify-center mt-6"
      }, /*#__PURE__*/React.createElement("img", {
        src: CDN_LINK + "/assets/images/payment/done.svg",
        alt: ""
      }), /*#__PURE__*/React.createElement("h3", {
        className: "text-primary-new text-base font-bold leading-6 mt-4 mb-4 max-lg:mb-2"
      }, tShort("remaining/car_payment_completed", {
        ns: "web_tracking"
      })), date && /*#__PURE__*/React.createElement("div", {
        className: "flex justify-center items-center gap-2.5"
      }, /*#__PURE__*/React.createElement("p", {
        className: "text-primary-new text-sm font-semibold leading-6"
      }, localizedDate.day, ",", " ", /*#__PURE__*/React.createElement("span", {
        className: "font-bold"
      }, localizedDate.date)), /*#__PURE__*/React.createElement("p", {
        className: "text-primary-new text-sm font-semibold leading-6"
      }, /*#__PURE__*/React.createElement("span", {
        className: "font-bold"
      }, localizedTime.time, " "), localizedTime.format)));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-4"
    }, warrantyV2 && ((_warrantyV2$items2 = warrantyV2.items) === null || _warrantyV2$items2 === void 0 ? void 0 : _warrantyV2$items2.length) > 0 && selectedWarranty && /*#__PURE__*/React.createElement(WarrantyRemaining, {
      warranty: selectedWarranty,
      options: resolvedWarrantyOptions,
      onSelect: handleWarrantySelect,
      isLoading: isWarrantyUpdating,
      isDefaultSelected: isDefaultWarrantySelected,
      order_id: localOrder === null || localOrder === void 0 ? void 0 : localOrder.id,
      referral_location: "remaining_payment",
      order_type: (_localOrder$payment_t = localOrder === null || localOrder === void 0 ? void 0 : localOrder.payment_type) !== null && _localOrder$payment_t !== void 0 ? _localOrder$payment_t : "cash"
    }), /*#__PURE__*/React.createElement(SharedRemDataComp, _extends({}, sharedDataProps, {
      hideTheName: backFromTracking || (state === null || state === void 0 ? void 0 : state.backFromSteps) || !!(warrantyV2 && ((_warrantyV2$items3 = warrantyV2.items) === null || _warrantyV2$items3 === void 0 ? void 0 : _warrantyV2$items3.length) > 0 && selectedWarranty)
    })), /*#__PURE__*/React.createElement("span", {
      className: "text-center text-navy-primary text-xs font-medium"
    }, tShort("remaining/multiple_transfer", {
      ns: "web_common"
    }))));
  };
  var renderBody = function renderBody() {
    if (isPaid) {
      return /*#__PURE__*/React.createElement(SharedRemDataComp, _extends({}, sharedDataProps, {
        hideTheName: true
      }));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentMethods, paymentMethodsProps));
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "bg-blue-alice px-6 pb-[38px] pt-6 rounded-t-2xl lg:min-h-[280px] max-lg:px-4 max-lg:pb-10 max-lg:rounded-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-hide"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-blue-old text-center text-base font-bold leading-6 mb-8"
  }, title), isBackVisible && /*#__PURE__*/React.createElement(ArrowType2SVG, {
    filledColor: "#154F9C",
    className: "m-show fixed top-6 right-4 left-4",
    onClick: function onClick() {
      return navigateTo("/tracking-checkout-details/".concat(id));
    }
  })), renderHeader()), /*#__PURE__*/React.createElement("div", {
    className: "bg-blue-alice rounded-b-[30px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("w-full h-full pb-2 bg-gray-snow shadow-[0px_-4px_14.3px_rgba(0,0,0,0.11)] rounded-t-[30px] pt-6", isPaid && "pt-[30px]")
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-4"
  }, renderBody())), !showBackLink && isBackVisible && /*#__PURE__*/React.createElement("div", {
    className: twMerge("w-full flex justify-center items-center pt-12 pb-5 bg-white rounded-b-[30px]", isPaid && "max-lg:fixed max-lg:bottom-6 max-lg:left-4 max-lg:right-4 max-lg:w-[calc(100%-32px)]")
  }, /*#__PURE__*/React.createElement(Link, {
    to: createUrl(isFinance ? "/tracking-finance-details/".concat(id) : "/tracking-checkout-details/".concat(id)),
    className: "block rounded border border-primary-new bg-white py-3 text-primary-new text-center text-base font-bold leading-6 w-[382px] max-lg:w-[85%]"
  }, tShort("remaining/back", {
    ns: "web_tracking"
  })))));
};
export default RemainingPaymentComponent;